import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import ApiProvider from "../providers/ApiProvider";
import AuthProvider from "../providers/AuthProvider";
import AppRouting from "./AppRouting";
import AppHeader from "./AppHeader";
import AppBody from "./AppBody";
import AuthCheck from "../components/auth/AuthCheck";
import { theme } from "../theme";

function App() {
  return (
    <CssBaseline>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <ApiProvider>
            <AuthCheck>
                <AppRouting>
                  <>
                    <AppHeader />
                    <AppBody />
                  </>
                </AppRouting>
            </AuthCheck>
          </ApiProvider>
        </AuthProvider>
      </ThemeProvider>
    </CssBaseline>
  );
}

export default App;
